module.exports = function() {
  return new Worker(__webpack_public_path__ + "f71e41c033b14b634368.worker.js");
};